import styled from 'styled-components';

export default styled.div`
  && {
    .section {
      padding: 25px 65px;
      .confirm-register {
        background-color: rgba(238, 238, 238, 1);
        padding: 50px 30px;
      }
      .mb-40 {
        margin-bottom: 40px;
      }
      .mb-35 {
        margin-bottom: 35px;
      }
      .mb-10 {
        margin-bottom: 10px;
      }
      .flex-align {
        display: flex;
        align-items: center;
      }
      .label {
        margin-top: 25px;
        font-weight: bold;
        font-size: 12px;
      }
      .textarea {
        padding: 10px;
        background: #f4f4f4;
        border-radius: 5px;
        height: 100px;
        overflow-y: auto;
        white-space: pre;
      }
      .submit {
        display: flex;
        align-items: center;
        flex-direction: column;
        margin-top: 30px;
        margin-bottom: 30px;
        .text {
          text-align: center;
          margin-bottom: 20px;
        }
        .btn {
          width: 240px;
          height: 60px;
        }
      }
      .confirm-register-form {
        text-align: center;
        margin-top: 30px;
      }
      .confirm-register-btn {
        margin-top: 36px;
        display: flex;
        justify-content: center;
        align-items: center;
        .btn-save {
          background-color: #ff8a00;
          border-radius: 4px;
          color: white;
          border: none;
          width: 240px;
          height: 60px;
        }
        .btn-cancel-save {
          width: 112px;
          height: 60px;
          background-color: #c4c4c4;
          border-radius: 4px;
          border: none;
          color: white;
          margin-right: 10px;
        }
      }
    }
  }
`;
